export default {
  root: ({ props, context, parent, instance }) => ({
    class: ["datatable-root"],
  }),
  header: {
    class: ["datatable-tableheader"],
  },
  tablecontainer: {
    class: ["datatable-tablecontainer"],
  },
  table: {
    class: ["datatable-table"],
  },
  thead: {
    class: ["datatable-thead"],
  },
  headerrow: {
    class: ["datatable-header-row"],
  },
  bodyrow: {
    class: ["datatable-body-row"],
  },
};